var map = {
	"./personality-relax-beijing.mp4": "6c50",
	"./personality-relax-bingdao.mp4": "d919",
	"./personality-relax-riben.mp4": "1fde",
	"./personality-relax-shenzhen.mp4": "6e36",
	"./personality-relax-taiguo.mp4": "313f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ee9";